import { ChangeDetectionStrategy, Component } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import * as FlatModels from "@medsurf/flat-models";
import * as FlatFacades from "@medsurf/flat-facades";

@Component({
    selector: 'medsurf-slide-edit-free-form-free',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './free-form-free.component.html',
    styleUrls: ['./free-form-free.component.scss'],
    standalone: false
})
export class FreeFormFreeComponent {
  freeFormStyle: FlatModels.FreeFormStyleEntityModels.FreeFormStyle;
  readonly FlatModels = FlatModels;
  
  constructor(public slideAuthorFacade: FlatFacades.SlideAuthorFacade) {
    // Update Free Form Style
    this.slideAuthorFacade.currentSelectedSlideFreeFormStyle$.pipe(takeUntilDestroyed()).subscribe((freeFormStyle) => {
      if (freeFormStyle) {
        this.freeFormStyle = freeFormStyle;
      }
    });
  }
}
